import { required, size } from 'vee-validate/dist/rules'
import { extend, ValidationProvider, ValidationObserver, setInteractionMode } from "vee-validate"
setInteractionMode("eager")
extend("required", {
    ...required,
    message: "{_field_} no puede estar vacio",
})

const carousel = {
    components: { ValidationObserver, ValidationProvider },
    data: () => ({
        loading: false,
        dialog: false,
        selectedImage: null,
        loadingShow: {},
        loadingTbl: false,
        createDialog: false,
        loadingDel: {},
        file: null,
        files: [],
        description: '',
        headers: [
            { text: "ID", value: "id", align: 'start', sortable: false },
            { text: "Nombre imagen", value: "nombre_imagen", align: 'start', sortable: false },
            { text: "Descripcion", value: "descripcion", align: 'start', sortable: false },
            // { text: "Cargado por", value: "creadorNombre", align: 'start', sortable: false },
            // { text: "Fecha de Carga", value: "fecha_carga", align: 'start', sortable: false },
            { text: "Se muestra en carrusel", value: "mostrar_imagen", align: 'start', sortable: false },
            { text: "Vista previa imagen", value: "showImage", align: 'start', sortable: false },
            { text: "Acciónes", value: "action", align: 'start', sortable: false }
        ]
    }),
    mounted() {
        this.fetchFiles();
    },
    computed: {
        creatorId() {
            return this.$store.state.id;
        },
        Rol() {
            return this.$store.state.rol;
        },
    },
    methods: {
        showImageDialog(item) {
            this.selectedImage = item.s3_url;
            this.dialog = true;
        },
        async uploadFile(reset) {
            var ancho = 0;
            var alto = 0;

            this.loading = true
            if (!this.file) {
                this.$refs.datos.setErrors({
                    Imagen: ['Debe seleccionar una imagen']
                });
                return;
            }

            console.log(this.file);
            
            // Validar el tipo de archivo
            const validTypes = ['image/jpeg', 'image/png', 'image/gif'];
            if (!validTypes.includes(this.file.type)) {
                this.$refs.datos.setErrors({
                    Imagen: ['El archivo debe ser una imagen (jpeg, png, gif)'],
                });
                return;
            }

            // const img = new Image();
            // const reader = new FileReader();

            // reader.onload = (e) => {
            //     img.onload = () => {
            //         ancho = img.width;
            //         alto = img.height;
            //     };
            //     img.src = e.target.result;
            //     console.log(img.width, img.height);
            // };

            // reader.readAsDataURL(this.file);

            // if(ancho != 1600 || alto != 600){
            //     this.loading = false
            //     this.$toast.error('El tamaño de la imagen no es la correcta');
            //     return false;
            // }

            

            let formData = new FormData();
            formData.append('file', this.file);
            formData.append('description', this.description);
            formData.append('uploaded_by', this.creatorId);


            try {
                let response = await this.$axios.post('uploadFile', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                this.file = null;
                this.description = '';
                reset();
                this.fetchFiles();
                this.$toast.success('Datos guardados con exito');
            } catch (error) {
                this.$toast.error('Hubo un error al guardar los datos');
                //console.error('Error al subir el archivo:', error);
            } finally {
                this.loading = false
            }
        },
        async fetchFiles() {
            this.loadingTbl = true;
            try {
                let response = await this.$axios.get('getFiles');
                this.files = response.data.files;
            } catch (error) {
                console.error('Error al obtener los archivos:', error);
            } finally {
                this.loadingTbl = false;
            }
        },
        async deleteFile(fileId) {
            this.$set(this.loadingDel, fileId, true); // Activa el estado de carga solo para la imagen específica
            try {
                const response = await this.$axios.delete('deleteFiles', { data: { file: fileId } });
                this.files = this.files.filter(f => f.id !== fileId);
                this.$toast.success('Elemento eliminado con exito');
            } catch (error) {
                this.$toast.error('Hubo un error al eliminar el elemento');
                //console.error('Error al eliminar el archivo:', error);
            } finally {
                this.$set(this.loadingDel, fileId, false); // Desactiva el estado de carga después de eliminar la imagen
            }
        },
        async showImage(fileId) {
            this.$set(this.loadingShow, fileId, true); // Inicia el indicador de carga
            try {
                const response = await this.$axios.post('showImage', { file: fileId });
                const newValue = response.data.new_value;
                this.files = this.files.map(file => {
                    if (file.id === fileId) {
                        file.mostrar_imagen = newValue;
                    }
                    return file;
                });
                this.$toast.success('Los cambios se guadaron con exito');
                //this.fetchFiles();
            } catch (error) {
                this.$toast.success('Hubo un error al guardar los cambios');
                //console.error('Error al actualizar el estado de mostrar_imagen:', error);
            } finally {
                this.$set(this.loadingShow, fileId, false); // Detiene el indicador de carga
            }
        },
        openForm(){
            this.createDialog = true;
        }
    }
}
export default carousel